import { ELSCommonUIConstants } from 'components/common';
import { facadeApi } from 'helpers/api.helper';
export var fetchFeatureFlagWithToken = function (key, token, app) {
    if (app === void 0) { app = ELSCommonUIConstants.appIds.PERFORMANCE_REPORT.toUpperCase(); }
    return facadeApi.get("/features/app/".concat(app, "/key/").concat(key), {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    });
};
export var fetchFeatureFlags = function () { return facadeApi.get("/features/app/".concat(ELSCommonUIConstants.appIds.PERFORMANCE_REPORT.toUpperCase())); };
export var isFeatureEnabled = function (featureFlags, featureName, groupId) {
    if (featureName) {
        var featureFlagByName = (featureFlags || []).filter(function (flag) { return flag.featureName === featureName; });
        var featureFlagByGroupId = featureFlagByName.find(function (flag) { return flag.group === groupId; }) || featureFlagByName.find(function (flag) { return flag.group === 'ALL' || flag.group === null; });
        if (featureFlagByGroupId) {
            return featureFlagByGroupId.featureValue === 'true';
        }
    }
    return false;
};
export var getFeatureFlagValue = function (featureFlags, featureName, groupId) {
    if (featureName) {
        var featureFlagByName = (featureFlags || []).filter(function (flag) { return flag.featureName === featureName; });
        var featureFlagByGroupId = featureFlagByName.find(function (flag) { return flag.group === groupId; }) || featureFlagByName.find(function (flag) { return flag.group === 'ALL' || flag.group === null; });
        if (featureFlagByGroupId) {
            return featureFlagByGroupId.featureValue;
        }
    }
    return '';
};
